// extracted by mini-css-extract-plugin
module.exports = {"background":"Login_background__3TxZ9","wrapper":"Login_wrapper__3NQO2","header":"Login_header__jUkq5","body":"Login_body__2LF1f","submit":"Login_submit__3SAhI"};